import { TranslationsType } from "@/app/translations/Translations";

export const T_Common: TranslationsType = {
  DR: {
    EN_US: "Dr.",
    FR_FR: "Dr.",
  },
  OPTIONAL: {
    EN_US: "optional",
    FR_FR: "optionnel",
  },
  APP_TITLE: {
    EN_US: "Kliq Pro",
    FR_FR: "Kliq Pro",
  },
  APP_DESCRIPTION: {
    EN_US: "Professional platform for podiatrists and orthopedic practitioners.",
    FR_FR: "Plateforme professionnelle pour podologues et praticiens orthopédiques.",
  },
  APP_KEYWORDS: {
    EN_US: "podiatry, orthopedics, insoles, practitioner",
    FR_FR: "podologie, orthopédie, semelles, praticien",
  },
  EDIT: {
    EN_US: "Edit",
    FR_FR: "Modifier",
  },
  CANCEL: {
    EN_US: "Cancel",
    FR_FR: "Annuler",
  },
  CONFIRM_TITLE: {
    EN_US: "Are you sure?",
    FR_FR: "Êtes-vous sûr ?",
  },
  SAVE: {
    EN_US: "Save",
    FR_FR: "Enregistrer",
  },
  CREATED_ON: {
    EN_US: "Created",
    FR_FR: "Créé le",
  },
  UPDATED_ON: {
    EN_US: "Modified",
    FR_FR: "Modifié le",
  },
  MEASURE: {
    EN_US: "Measure",
    FR_FR: "Mesure",
  },
  INVERT_SIDE: {
    EN_US: "Flip side",
    FR_FR: "Inverser le côté",
  },
  MEASURE_TOOLS: {
    EN_US: "Measurement tools",
    FR_FR: "Outils de mesure",
  },
  MEASURE_HINT: {
    EN_US: "Click on the insole to place measurement points.",
    FR_FR: "Cliquez sur la semelle pour placer des points de mesure.",
  },
  MEASURE_POINT_TO_POINT: {
    EN_US: "Point to point",
    FR_FR: "Point à point",
  },
  MEASURE_POINT_TO_GROUND: {
    EN_US: "Point to ground",
    FR_FR: "Point au sol",
  },
  MEASURE_EMPTY: {
    EN_US: "No measurement yet.",
    FR_FR: "Aucune mesure pour le moment.",
  },
  MEASURE_KEEP_VISIBLE: {
    EN_US: "Keep measurements visible",
    FR_FR: "Garder les mesures affichées",
  },
  RESET: {
    EN_US: "Reset",
    FR_FR: "Réinitialiser",
  },
  EXPORT: {
    EN_US: "Export (STL)",
    FR_FR: "Exporter (STL)",
  },
  EXPORT_BOTH: {
    EN_US: "Both feet",
    FR_FR: "Les deux pieds",
  },
  EXPORT_IN_PROGRESS: {
    EN_US: "Exporting…",
    FR_FR: "Export en cours…",
  },
  EXPORT_NOT_WATERTIGHT_TITLE: {
    EN_US: "Mesh not watertight",
    FR_FR: "Maillage non étanche",
  },
  EXPORT_NOT_WATERTIGHT_MESSAGE: {
    EN_US:
      "This model has open or non-manifold edges, so 3D printing may fail or need repair. Export anyway?",
    FR_FR:
      "Ce modèle comporte des bords ouverts ou non conformes, l'impression 3D peut échouer ou nécessiter une réparation. Exporter quand même ?",
  },
  DELETE: {
    EN_US: "Delete",
    FR_FR: "Supprimer",
  },
  SETTINGS: {
    EN_US: "Settings",
    FR_FR: "Paramètres",
  },
  SIGN_OUT: {
    EN_US: "Sign out",
    FR_FR: "Se déconnecter",
  },
  GENERAL: {
    EN_US: "General",
    FR_FR: "Général",
  },
  OVERVIEW: {
    EN_US: "Overview",
    FR_FR: "Vue d'ensemble",
  },
  OVERVIEW_TOTAL: {
    EN_US: "Total",
    FR_FR: "Total",
  },
  FIRST_NAME: {
    EN_US: "First name",
    FR_FR: "Prénom",
  },
  LAST_NAME: {
    EN_US: "Last name",
    FR_FR: "Nom",
  },
  PHONE: {
    EN_US: "Phone",
    FR_FR: "Téléphone",
  },
  NOT_FOUND_TITLE: {
    EN_US: "Page not found",
    FR_FR: "Page introuvable",
  },
  NOT_FOUND_TEXT: {
    EN_US: "The page you're looking for doesn't exist or has been moved.",
    FR_FR: "La page que vous cherchez n'existe pas ou a été déplacée.",
  },
  NOT_FOUND_ACTION: {
    EN_US: "Back to home",
    FR_FR: "Retour à l'accueil",
  },
  MANAGE: {
    EN_US: "Manage",
    FR_FR: "Gérer",
  },
};
